import { Component, Input, Inject } from '@angular/core';
import moment from 'moment';

export const imageByType = {
    2: 'redCircle',
    1: 'orangeCircle',
    0: 'greenCircle '
};

@Component({
    selector: 'activity-item',
    template: require('./activity-item.component.html'),
    styles: [require('./activity-item.component.scss')]
})
export class ActivityItemComponent {
    @Input() public item: any;
    @Input() public isFirst: boolean;

    constructor(@Inject('processDetailsModalService') private processDetailsModalService: any) {
    }

    public getImage(type: any) {
        return `dbm-${imageByType[type]}`;
    }

    public convertUTCtoLocal(date: any) {
        if (!date) {
            return '';
        }
        const stillUtc = moment.utc(date , 'DD/MM/yyyy HH:mm:ss').toDate();
        const local = moment(stillUtc).local().toDate();
        return local.toLocaleString();
    }

    public showActivityDetails() {
        if (this.item.jobQId != null) {
            const data = { JobQId: this.item.jobQId, activityIcon: this.getImage(this.item.type) };
            this.processDetailsModalService.OpenProcessDetailsModal(data, true);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/pipeline/activities/activity-item/activity-item.component.ts